<template>
  <b-form @submit.prevent="handleSave">
    <b-alert variant="info" show>
      <strong>Виртуальное считывание</strong> - ручное добавление времени на чекпоинте
      без физического чипа
    </b-alert>

    <b-form-group label="Участник" v-if="participant">
      <b-form-input :value="getParticipantName()" disabled />
    </b-form-group>

    <b-form-group label="Чекпоинт" v-if="checkpoint">
      <b-form-input :value="checkpoint.header || checkpoint.point" disabled />
    </b-form-group>

    <b-form-group
      label="Время (timestamp)"
      description="ISO формат или локальное время"
    >
      <b-form-input
        v-model="formData.timestamp"
        type="datetime-local"
        required
      />
    </b-form-group>

    <b-form-group label="RSSI (опционально)">
      <b-form-input
        v-model="formData.rssi"
        type="number"
        placeholder="0"
      />
    </b-form-group>

    <b-form-group label="Антенна (опционально)">
      <b-form-input
        v-model="formData.antena"
        placeholder="virtual"
      />
    </b-form-group>

    <b-form-group label="Причина добавления">
      <b-form-textarea
        v-model="formData.reason"
        placeholder="Опишите причину добавления виртуального считывания"
        rows="3"
      />
    </b-form-group>

    <div class="text-right">
      <b-button variant="outline-secondary" class="mr-2" @click="$emit('cancel')">
        Отмена
      </b-button>
      <b-button type="submit" variant="success">
        Добавить виртуальное считывание
      </b-button>
    </div>
  </b-form>
</template>

<script>
import { BForm, BFormGroup, BFormInput, BFormTextarea, BButton, BAlert } from 'bootstrap-vue'

export default {
  name: 'VirtualReadingForm',
  components: {
    BForm,
    BFormGroup,
    BFormInput,
    BFormTextarea,
    BButton,
    BAlert,
  },
  props: {
    checkpoint: {
      type: Object,
      default: null,
    },
    participant: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      formData: {
        timestamp: '',
        rssi: '0',
        antena: 'virtual',
        reason: '',
      },
    }
  },
  methods: {
    getParticipantName() {
      if (!this.participant) return ''
      
      const name = this.participant.name || ''
      const secondName = this.participant.secondName || ''
      
      return secondName && name ? secondName + ' ' + name : name || secondName || this.participant.userId
    },

    handleSave() {
      // Convert datetime-local to ISO
      const timestamp = this.formData.timestamp
        ? new Date(this.formData.timestamp).toISOString()
        : new Date().toISOString()

      this.$emit('save', {
        userId: this.participant.userId,
        point: this.checkpoint.point,
        timestamp: timestamp,
        lap: this.checkpoint.lap,
        rssi: this.formData.rssi,
        antena: this.formData.antena,
        reason: this.formData.reason,
      })

      // Reset form
      this.formData = {
        timestamp: '',
        rssi: '0',
        antena: 'virtual',
        reason: '',
      }
    },
  },
}
</script>

<style scoped>
.text-right {
  text-align: right;
}
</style>

